import ViewerPDFService from '@/modules/signers/services/viewerPDFService'

const labelsPDFDefault = {
  title: 'Ocurrió un problema al descargar el PDF',
  message: 'No fue posible descargar el PDF.'
}

export default {
  namespaced: true,
  state: () => {
    return {
      url: null,
      file: '',
      ok: false,
      info: false,
      numPages: undefined,
      labels: labelsPDFDefault,
      pdfBusy: false
    }
  },
  mutations: {
    SET_URL(state, url) {
      state.url = url
    },
    SET_FILE(state, file) {
      state.file = file
    },
    SET_OK(state, ok){
      state.ok = ok
    },
    SET_INFO(state, info){
      state.info = info
    },
    SET_LABELS(state, labels){
      state.labels = labels 
    },
    SET_NUM_PAGES(state, pages){
      state.numPages = pages
    },
    SET_PDF_BUSY(state, busy){
      state.pdfBusy = busy
    }
  },
  actions: {
    setUrlPDF({ commit, state }, url) {
      commit('SET_PDF_BUSY', true)
      commit('SET_URL', null)
      commit('SET_OK', false)
      commit('SET_INFO', false)
      commit('SET_NUM_PAGES', undefined)
      commit('SET_LABELS', labelsPDFDefault)

      const service = new ViewerPDFService()
      commit('SET_FILE', service.downloadPDF(url))
      
      state.file.promise
      .then(resp => {
        commit('SET_URL', url)
        commit('SET_NUM_PAGES', resp.numPages)
      })
      .catch(err=> {
        commit('SET_INFO', true)
        commit('SET_PDF_BUSY', false)
      })
    },
    setPDFOk({ commit }) {
      commit('SET_OK', true)
      commit('SET_PDF_BUSY', false)
    },
    setInfoPDF({ commit }, info){
      commit('SET_INFO', info)
    },
    setLabelsPDF({ commit }, labels){
      commit('SET_LABELS', labels)
    },
    cleanObjectPDF({commit}){
      commit('SET_URL', null)
      commit('SET_FILE', '')
      commit('SET_OK', false)
      commit('SET_INFO', false)
      commit('SET_NUM_PAGES', undefined)
      commit('SET_LABELS', labelsPDFDefault)
      commit('SET_PDF_BUSY', false)
    },
    downloadDocumentPdf({ dispatch }, documentId) {
      let downloadService = null
      const service = new ViewerPDFService()
      downloadService = service.getPresignedDocument(documentId)
      dispatch('downloadPdf', downloadService)
    },
    downloadDocumentPdfByToken({ dispatch }, token) {
      let downloadService = null
      const service = new ViewerPDFService()
      downloadService = service.getPresignedDocumentByToken(token)
      dispatch('downloadPdf', downloadService)
    },
    downloadPdf({ dispatch, commit }, downloadService){
      dispatch('cleanObjectPDF')
      commit('SET_PDF_BUSY', true)
      downloadService
      .then(result => {
        dispatch('setUrlPDF', result.data.data)
      })
      .catch(err => {
        commit('SET_PDF_BUSY', false)
        dispatch('setLabelsPDF', {
          title: labelsPDFDefault.title,
          message: err.response.data.error.message
        })
        dispatch('setInfoPDF', true)
      })
    }
  },
  getters:{
    urlPDF(state) {
      return state.url
    },
    filePDF(state) {
      return state.file
    },
    okPDF(state){
      return state.ok
    },
    infoPDF(state){
      return state.info
    },
    labelsPDF(state){
      return state.labels
    },
    numPages(state){
      return state.numPages
    },
    pdfIsBusy(state){
      return state.pdfBusy
    }
  }
}